// Added by Vinaya - KMS encryption for mobile number and email (PII)
import kmsEncryption from '../../../services/kmsEncryption';

export const buildCreateUserPayload = async (user) => {
  let encryptedMobile = user.mobileNumber || '';
  let encryptedEmail = user.emailId;
  let encryptedDataKey = null;

  // Encrypt mobile number and email if they exist
  if (user.mobileNumber || user.emailId) {
    // Ensure KMS encryption is initialized before getting the key
    if (!kmsEncryption.isReady()) {
      await kmsEncryption.initializeDataKey();
    }
    encryptedDataKey = kmsEncryption.getEncryptedDataKey();
    if (user.mobileNumber) {
      encryptedMobile = await kmsEncryption.encryptField(user.mobileNumber);
    }
    if (user.emailId) {
      encryptedEmail = await kmsEncryption.encryptEmail(user.emailId);
    }
  }

  return {
    // UserID will be auto-generated by backend counter, not sent from frontend
    UserName: user.userName,
    UserType: user.userType,
    Role: user.role,
    Division: user.division,
    Location: user.location,
    BPCode: user.bpCode,
    EmailID: encryptedEmail,
    MobileNumber: encryptedMobile,
    EncryptedDataKey: encryptedDataKey,
    Status: user.status ? 'Active' : 'Inactive',
    CreatedBy: sessionStorage.getItem('userName') || sessionStorage.getItem('userEmail') || '',
    CreatedOn: new Date().toISOString(),
    IsDeleted: false,
  };
};

export const buildUpdateUserPayload = async (user, originalUser) => {
  // Always encrypt the current form values if they exist
  let encryptedMobile = '';
  let encryptedEmail = user.emailId || '';
  let encryptedDataKey = null;

  // Encrypt if mobile number or email exists in form
  if (user.mobileNumber || user.emailId) {
    // Ensure KMS encryption is initialized before getting the key
    if (!kmsEncryption.isReady()) {
      await kmsEncryption.initializeDataKey();
    }
    encryptedDataKey = kmsEncryption.getEncryptedDataKey();
    
    if (user.mobileNumber) {
      encryptedMobile = await kmsEncryption.encryptField(user.mobileNumber);
    }
    
    if (user.emailId) {
      encryptedEmail = await kmsEncryption.encryptEmail(user.emailId);
    }
  }

  return {
    UserID: originalUser.userId,
    UserName: user.userName,
    UserType: user.userType,
    Role: user.role,
    Division: user.division,
    Location: user.location,
    BPCode: user.bpCode,
    EmailID: encryptedEmail,
    MobileNumber: encryptedMobile,
    EncryptedDataKey: encryptedDataKey,
    Status: user.status ? 'Active' : 'Inactive',
    CreatedBy: originalUser.insertedBy,
    CreatedOn: originalUser.originalCreatedOn,
    ModifiedBy: sessionStorage.getItem('userName') || sessionStorage.getItem('userEmail') || '',
    ModifiedOn: new Date().toISOString(),
    IsDeleted: false,
  };
};

export const buildDeleteUserPayload = async (user) => {
  return {
    UserID: user.userId, // Use existing UserID from user object
    UserName: user.userName,
    UserType: user.userType,
    Role: user.role,
    Division: user.division,
    Location: user.location,
    BPCode: user.bpCode,
    EmailID: user.emailId,
    MobileNumber: user.mobileNumber || '',
    Status: user.status,
    CreatedBy: user.insertedBy,
    CreatedOn: user.originalCreatedOn,
    ModifiedBy: sessionStorage.getItem('userName') || sessionStorage.getItem('userEmail') || '',
    ModifiedOn: new Date().toISOString(),
    IsDeleted: true,
  };
};

export const buildUserGridEntry = (payload) => {
  return {
    userId: payload.UserID,
    userName: payload.UserName,
    userType: payload.UserType,
    role: payload.Role,
    division: payload.Division,
    location: payload.Location,
    bpCode: payload.BPCode,
    emailId: payload.EmailID,
    displayUserName: payload.UserName || 'Unknown User',
    mobileNumber: payload.MobileNumber,
    status: payload.Status,
    insertedBy: payload.CreatedBy,
    insertedOn: new Date().toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }),
    modifiedBy: payload.CreatedBy,
    modifiedOn: new Date().toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }),
  };
};
